function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../../_snowpack/pkg/react.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import classNames from '../../../_snowpack/pkg/classnames.js';
import IconCheck from '../../icons/check.js';
const Outer = styled.span.withConfig({
  displayName: "checkbox__Outer",
  componentId: "sc-13vjyss-0"
})(["--border-radius:2px;border-radius:var(--border-radius);display:inline-flex;position:relative;label:active ~ &{transform:scale(0.9);}&.checked{background-color:HSL(165.7,100%,95.9%);> .checkmark{border-color:hsl(166,54%,72%);> svg{visibility:visible;}}}"]);
const Box = styled.span.withConfig({
  displayName: "checkbox__Box",
  componentId: "sc-13vjyss-1"
})(["--size:18px;align-items:center;border-color:hsl(0,0%,87%);border-radius:var(--border-radius);border-style:solid;border-width:1px;display:flex;height:var(--size);justify-content:center;width:var(--size);svg{width:calc(var(--size) - 6px);height:calc(var(--size) - 6px);visibility:hidden;}"]);
const Input = styled.input.withConfig({
  displayName: "checkbox__Input",
  componentId: "sc-13vjyss-2"
})(["cursor:pointer;height:100%;left:0;margin:0;opacity:0;position:absolute;top:0;width:100%;&[disabled]{cursor:not-allowed;}"]);
export function Checkbox(props) {
  const {
    checked,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement(Outer, {
    className: classNames({
      checked
    })
  }, /*#__PURE__*/React.createElement(Box, {
    className: "checkmark"
  }, /*#__PURE__*/React.createElement(IconCheck, null)), /*#__PURE__*/React.createElement(Input, _extends({
    type: "checkbox",
    checked: checked
  }, rest)));
}